import { render, staticRenderFns } from "./TextEditorNew.vue?vue&type=template&id=28d969d0&"
import script from "./TextEditorNew.vue?vue&type=script&lang=js&"
export * from "./TextEditorNew.vue?vue&type=script&lang=js&"
import style0 from "./TextEditorNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports